import React, { useEffect, useState } from "react";
import Video from "./Video";

const Videocontainer = (props) => {
  const [vidToLoad, setvidToLoad] = useState([]);
  var isScrollable = true;

  useEffect(() => {
    setvidToLoad([]);
    if (vidToLoad.length < props.Vid.length) {
      let videoLength =
        vidToLoad.length + 12 <= props.Vid.length
          ? vidToLoad.length + 12
          : props.Vid.length;
      let MyArr = [];
      for (var i = 0; i < videoLength; i++) {
        MyArr.push(JSON.parse(JSON.stringify(props.Vid[i])));
      }
      setvidToLoad(MyArr);
    }
  }, [props.Vid]);

  const handleScroll = (e) => {
    if (isScrollable) {
      if (e.target.scrollHeight - e.target.scrollTop <= e.target.offsetHeight) {
        isScrollable = false;
        if (vidToLoad.length < props.Vid.length) {
          let videoLength =
            vidToLoad.length + 12 <= props.Vid.length
              ? vidToLoad.length + 12
              : props.Vid.length;

          let MyArr = [];
          for (var i = vidToLoad.length; i < videoLength; i++) {
            MyArr.push(JSON.parse(JSON.stringify(props.Vid[i])));
          }
          setvidToLoad(vidToLoad.concat(MyArr));
          isScrollable = true;
        }
      }
    }
  };

  return (
    <>
      {" "}
      <div
        onScroll={handleScroll}
        className="videotemplate d-flex scrollbar style-1"
      >
        <div className="columnvido1">
          {vidToLoad.map((Videos, index) => {
            return (
              index % 2 === 0 && (
                <Video
                  VideoHeight={Videos.video_files[2].height}
                  VideoWidth={Videos.video_files[2].width}
                  key={index}
                  url={Videos.image}
                  duration={Videos.duration}
                  VideoUrl={Videos.video_files[2].link}
                />
              )
            );
          })}
        </div>

        <div className="columnvideo2">
          {vidToLoad.map((Videos, index) => {
            return (
              index % 2 !== 0 && (
                <Video
                  VideoHeight={Videos.video_files[2].height}
                  VideoWidth={Videos.video_files[2].width}
                  key={index}
                  url={Videos.image}
                  duration={Videos.duration}
                  VideoUrl={Videos.video_files[2].link}
                />
              )
            );
          })}
        </div>
      </div>
    </>
  );
};
export default Videocontainer;
